var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    _vm._g(_vm._b({}, "el-dialog", _vm.$attrs, false), _vm.$listeners),
    [
      _c("div", { staticClass: "dia-body-sty" }, [
        _c("div", { staticClass: "r-lab" }, [
          _c("p", { class: _vm.activeIndex === 0 ? "active" : "" }, [
            _vm._v("数字证书服务协议")
          ]),
          _c("p", { class: _vm.activeIndex === 1 ? "active" : "" }, [
            _vm._v("实名认证服务协议")
          ]),
          _c("p", { class: _vm.activeIndex === 2 ? "active" : "" }, [
            _vm._v("用户隐私政策协议")
          ])
        ]),
        _c("div", { staticClass: "l-lab" }, [
          _c(
            "div",
            { ref: "proRef", staticClass: "content-sty" },
            [
              _c("RealName", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeIndex === 2,
                    expression: "activeIndex === 2"
                  }
                ]
              }),
              _c("Privacy", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeIndex === 1,
                    expression: "activeIndex === 1"
                  }
                ]
              }),
              _c("Number", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeIndex === 0,
                    expression: "activeIndex === 0"
                  }
                ]
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                disabled: _vm.btnText.indexOf("请阅读至协议末尾") > -1
              },
              on: { click: _vm.nextProtocol }
            },
            [_vm._v(_vm._s(_vm.btnText))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59900eaf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59900eaf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/auth/APIAuth/components/protocalNew/index.vue
// module id = 3okH
// module chunks = 117